import React, { useCallback } from "react"
import Formsy from "formsy-react"
import types from "prop-types"
import clsx from "clsx"
import { useSubmit } from "hooks"
import * as API from "services/api"
import { Button, PrimaryButton } from "shared/buttons"
import { errorToast, successToast } from "components/shared/toast"
import WhitelistedUserEmailDescFormFields from "./WhitelistedUserEmailDescFormFields"

const CREATION_SUCCESSFUL_MESSAGE = "Whitelist entry created successfully!"
const CREATION_FAILURE_MESSAGE = "Record not saved:"

const NewWhitelistedUserEmailDescForm = ({
  addWhitelistedUserEmailDesc,
  className = "",
  onCancel,
  organizationSubdomain,
}) => {
  const { canSubmit, enableSubmit, disableSubmit } = useSubmit(false)

  const createOrganizationWhitelistedUserEmailDescription = useCallback(async (formData) => {
    if (window.confirm("Are you sure you want to submit? You will not be able to delete this entry.")) {
      const { description } = formData
      const response = await API.createOrganizationWhitelistedUserEmailDescription({ organizationSubdomain, description })

      if (response.ok) {
        successToast(CREATION_SUCCESSFUL_MESSAGE)
        addWhitelistedUserEmailDesc(response.data)
        onCancel()
      } else {
        const errorsString = response.data.errors.join(", ")
        errorToast(`${CREATION_FAILURE_MESSAGE} ${errorsString}`)
      }
    }
  }, [addWhitelistedUserEmailDesc, onCancel])

  return (
    <Formsy
      className={clsx(className)}
      onInvalid={disableSubmit}
      onInvalidSubmit={null}
      onValid={enableSubmit}
      onValidSubmit={createOrganizationWhitelistedUserEmailDescription}
    >
      <WhitelistedUserEmailDescFormFields
        className={canSubmit ? "mb-8" : "mb-16"}
      />
      <div className="flex justify-center">
        <PrimaryButton
          className="mr-4"
          disabled={!canSubmit}
          text="Add Domain or Email Address"
          type="submit"
        />
        <Button
          className="bg-white border border-lightgray-3"
          text="Cancel"
          onClick={onCancel}
        />
      </div>
    </Formsy>
  )
}

NewWhitelistedUserEmailDescForm.propTypes = {
  addWhitelistedUserEmailDesc: types.func.isRequired,
  className: types.string,
  onCancel: types.func.isRequired,
  organizationSubdomain: types.string.isRequired,
}

export default NewWhitelistedUserEmailDescForm
